import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'auth-service',
    pluginName: 'SETTINGS',
    entityName: 'AUTH_SERVICE',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch Authorization Services action creators
export const fetchAuthServiceInit = () => {
    return crudActions.fetchInit();
};
export const fetchAuthServiceStart = () => {
    return crudActions.fetchStart();
};
export const fetchAuthServiceSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchAuthServiceFail = () => {
    return crudActions.fetchFail();
};
export const fetchAuthServiceCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchAuthServiceStart());
        try {
            let countRes = await rest.post("auth-service/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchAuthServiceSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchAuthServiceFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch Authorization Services."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchAuthServiceFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch Authorization Services."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchAuthService = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchAuthServiceStart());
        try {
            let listRes = await rest.post("auth-service/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchAuthServiceSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchAuthServiceFail());
            return []

        } catch (error) {
            dispatch(fetchAuthServiceFail());
            return []
        }
    }
}

// Load Authorization Service action creators
export const loadAuthServiceInit = () => {
    return crudActions.loadInit();
};
export const loadAuthServiceStart = () => {
    return crudActions.loadStart();
};
export const loadAuthServiceSuccess = loadedAuthService => {
    return crudActions.loadSuccess(loadedAuthService);
};
export const loadAuthServiceFail = error => {
    return crudActions.loadFail(error);
};
export const loadAuthService = id => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(loadAuthServiceStart());
        try {
            let listRes = await rest.post("auth-service/load", id);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(loadAuthServiceSuccess(listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(loadAuthServiceFail());
            return null

        } catch (error) {
            dispatch(loadAuthServiceFail());
            return null
        }
    }
};

export const createAuthService = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/auth-service/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created Authorization Service.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create Authorization Service."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const editAuthService = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/auth-service/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated Authorization Service.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit Authorization Service."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Bulk delete Authorization Services action creators
export const bulkDeleteAuthServicesInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteAuthServicesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteAuthServicesSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteAuthServicesFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteAuthServices = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteAuthServicesStart());
        try {
            let res = await rest.post('/auth-service/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteAuthServicesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted Authorization Services.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteAuthServicesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete Authorization Services."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete Authorization Services."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteAuthServicesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};